export const colors = {
  dark: {
    1: '#727f8c',
    2: '#697581',
    3: '#606b77',
    4: '#57616c',
    5: '#4e5861',
    6: '#464e56',
    7: '#3d444b',
    8: '#343a40',
    9: '#2b3036',
    10: '#23272b',
    11: '#1a1d20',
    12: '#111315',
    13: '#08090a',
  },
  light: {
    1: '#fcfcfc',
    2: '#f2f2f2',
    3: '#e8e8e8',
    4: '#dfdfdf',
    5: '#d5d5d5',
    6: '#cbcbcb',
    7: '#c1c1c1',
    8: '#b7b7b7',
    9: '#aeaeae',
    10: '#a4a4a4',
    11: '#9a9a9a',
    12: '#909090',
    13: '#868686',
  },
  pink: {
    1: '#fde9f1',
    2: '#f9cade',
    3: '#f5a0c4',
    4: '#f073a8',
    5: '#eb498e',
    6: '#e72175',
    7: '#c41c63',
    8: '#a41753',
    9: '#841343',
    10: '#680f35',
    11: '#7e3856',
  },
  teal: {
    1: '#eafbf9',
    2: '#cdf6f1',
    3: '#a5efe5',
    4: '#7be7d9',
    5: '#54e0ce',
    6: '#2ed9c3',
    7: '#27b8a6',
    8: '#219a8a',
    9: '#1a7c6f',
    10: '#156258',
  },
  yellow: {
    1: '#fffae6',
    2: '#fff3c2',
    3: '#ffea92',
    4: '#ffe15f',
    5: '#ffd82f',
    6: '#ffcf01',
    7: '#d9b001',
    8: '#b59301',
    9: '#917601',
    10: '#735d00',
  },
  orange: {
    1: '#fffefc',
    2: '#fef5e9',
    3: '#feecd6',
    4: '#fde3c3',
    5: '#fddab0',
    6: '#fcd19d',
    7: '#fbc88a',
    8: '#fbbf77',
    9: '#fab664',
    10: '#faad51',
    11: '#f9a43e',
    12: '#f89b2b',
    13: '#f89218',
  },
  red: {
    1: '#fcf1f0',
    2: '#f8e1e0',
    3: '#f5d1d0',
    4: '#f1c1c0',
    5: '#eeb2b0',
    6: '#eaa2a0',
    7: '#e79290',
    8: '#e3827f',
    9: '#e0736f',
    10: '#dc635f',
    11: '#d9534f',
    12: '#d6433f',
    13: '#d2332f',
  },
  green: {
    1: '#f3faf3',
    2: '#e5f4e5',
    3: '#d7eed7',
    4: '#cae8ca',
    5: '#bce2bc',
    6: '#aedcae',
    7: '#a1d6a1',
    8: '#93d093',
    9: '#85ca85',
    10: '#78c478',
    11: '#6abe6a',
    12: '#5cb85c',
    13: '#4fb24f',
  },
  aqua: {
    1: '#ecf9ff',
    2: '#d1f1fe',
    3: '#ade6fd',
    4: '#87dafc',
    5: '#63cffc',
    6: '#41c4fb',
    7: '#37a7d5',
    8: '#2e8bb2',
    9: '#25708f',
    10: '#1d5871',
  },
  lime: {
    1: '#f9fcec',
    2: '#f0f8d1',
    3: '#e4f2ad',
    4: '#d7ec87',
    5: '#cbe663',
    6: '#c0e141',
    7: '#a3bf37',
    8: '#88a02e',
    9: '#6d8025',
    10: '#56651d',
  },
  purple: {
    1: '#f9f8fe',
    2: '#eae6fd',
    3: '#dcd4fb',
    4: '#cdc2fa',
    5: '#beaff8',
    6: '#af9df7',
    7: '#a18bf5',
    8: '#9279f4',
    9: '#8367f3',
    10: '#7555f1',
    11: '#6643f0',
    12: '#5730ee',
    13: '#481eed',
  },
  blue: {
    1: '#f1f8fe',
    2: '#dfeefc',
    3: '#cee4fa',
    4: '#bcdaf9',
    5: '#aad1f7',
    6: '#98c7f5',
    7: '#86bdf4',
    8: '#74b3f2',
    9: '#62aaf0',
    10: '#50a0ef',
    11: '#3e96ed',
    12: '#2c8ceb',
    13: '#1a82ea',
  },
  platinum: {
    1: '#b2bcc1',
    2: '#a5b1b7',
    3: '#98a6ad',
    4: '#8b9ba3',
    5: '#7f9099', // primary
    6: '#728189',
    7: '#65737a',
    8: '#58646b',
    9: '#4c565b',
    10: '#3f484c',
    11: '#32393d',
    12: '#262b2d',
    13: '#191c1e',
  },
  navy: {
    1: '#e7edf6',
    2: '#c6d3e8',
    3: '#9ab1d7',
    4: '#6a8cc4',
    5: '#3d6ab2',
    6: '#1349a1',
    7: '#103e89',
    8: '#0d3472',
    9: '#0b2a5c',
    10: '#092148',
  },
  livid: {
    1: '#eff1f5',
    2: '#d8dde6',
    3: '#b8c2d2',
    4: '#98a6bd',
    5: '#798baa',
    6: '#5b7297',
    7: '#4d6180',
    8: '#41516b',
    9: '#344156',
    10: '#292e37',
  },
};

export const general = {
  green: colors.green[12],
  orange: colors.orange[11],
  blue: colors.blue[11],
  grey: colors.light[5],
  platinum: colors.platinum[5],
  red: colors.red[6],
  purple: colors.purple[8],
  pink: colors.pink[5],
  black: colors.light[13],
  white: colors.light[1],
};

export const font = {
  dark: {
    normal: colors.light[1],
    secondary: colors.light[3],
    tertiary: colors.light[5],
    hover: colors.purple[8],
    focus: colors.purple[9],
    active: colors.purple[8],
    disabled: colors.light[7],
    link: colors.purple[8],
    error: colors.red[6],
    light: colors.light[7],
    dark: colors.light[7],
  },
};
